// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"38829f1f","453":"dde6fd07","532":"92e010dd"}[chunkId] + ".chunk.js";
};